// extracted by mini-css-extract-plugin
export default {"header":"Calendar_header__xR17p","purpleBackground":"Calendar_purpleBackground__Ussuj","calendarWrapper":"Calendar_calendarWrapper__q64QO"};